import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { ModalFinancialRowsOrderEditTable, ModalFinancialRowsOrderReadOnlyTable } from '../ModalFinancialRowsBaseTable'
import { SetCompleteDataTy } from '../../../../../types'
import { OrderHeaderURLs } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { financialRowTypesInversed } from '@teinor/erp/types/company/order/general'
import { useParams } from 'react-router'
import { DeleteRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import Checkbox from '../../../../../../../../../forms/Checkbox'
import { CustomSelectWithSearchBar } from '../../../../../../../../../forms/CustomSelect'
import InputDiscount from '../../../../../../../../../forms/Input/InputDiscount'
import { getUserInfo } from '../../../../../../../../../utils/reducers/getters'
import { OrderFinancialRowExtended } from '../../../types'
import useModalFinancialRowsOrderLogic from '../useModalFinancialRowsOrderLogic'

interface ModalAddRechargesOrderProps extends ModalEditComponentProps {
    tableData?: OrderTableData
    isReadOnly?: boolean
    setCompleteData: SetCompleteDataTy
    headerData: TwinDictionary
    orderHeaderURLs: OrderHeaderURLs
}

const ModalAddRechargesOrder: React.FC<ModalAddRechargesOrderProps> = ({ isReadOnly, headerData, ...rest }) => {
    const { t } = useTwinTranslation()
    const financialRowTypesDict: TwinDictionary = {
        2: { name: t('recharge', 'Recargo') },
        3: { name: t('rechargeWithCosts', 'Recargo con Costes') },
        4: { name: t('rechargeFinancial', 'Recargo Financiero') }
    }
    const currencyHeaderId = headerData.CurrencyId
    const params = useParams<{ id: string }>()
    const OrderId = parseInt(params.id || '')
    const { deleteRow, handleChangeFinancialRows, addTotalDiscountRow, myTotalDiscounts } = useModalFinancialRowsOrderLogic({ headerData, financialRowTypesDict, ...rest })
    const user = getUserInfo()
    const myColumns: ColumnTableSchema<OrderFinancialRowExtended> = [
        {
            id: 'discount',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            customRender: (value, rowData) => {
                const type = parseInt(rowData?.financialRowType)
                const myTotal = myTotalDiscounts?.[rowData.rowIndex]
                let maxDiscount: any = {}
                if (type === financialRowTypesInversed['discountWithoutCosts'] || type === financialRowTypesInversed['discountWithCosts']) {
                    maxDiscount = { maxPercentageDiscount: user?.Employee?.maxDiscount ? parseFloat(String(user?.Employee?.maxDiscount)) : 100, maxTotalDiscount: myTotal, maxUnitDiscount: 0 }
                } else {
                    maxDiscount = { maxPercentageDiscount: Infinity, maxTotalDiscount: Infinity, maxUnitDiscount: 0 }
                }
                return <InputDiscount label='' CurrencyId={currencyHeaderId} value={{ typeDiscount: rowData?.calculationType, discount: rowData?.quantity }} maxDiscount={maxDiscount} onChange={(newValue) => handleChangeFinancialRows(rowData.absoluteIndex, 'discount', newValue)} />
            }
        },
        {
            id: 'financialRowType',
            dataKey: 'financialRowType',
            label: t('type', 'Tipo'),
            customRender: (value, rowData) => <CustomSelectWithSearchBar className='w-full' label='' items={financialRowTypesDict} value={rowData?.financialRowType === financialRowTypesInversed['discountForTotalFooter'] ? financialRowTypesInversed['discountWithCosts'] : rowData?.financialRowType} readOnly={rowData?.financialRowType === financialRowTypesInversed['discountForTotalFooter']} onChange={(value) => handleChangeFinancialRows(rowData.absoluteIndex, 'financialRowType', parseInt(value))} />
        },
        {
            id: 'beforeTax',
            dataKey: 'beforeTax',
            label: t('beforeTax', 'Antes de impuestos'),
            customRender: (value, rowData) => <Checkbox label='' checked={rowData?.beforeTax} disabled={rowData?.financialRowType === financialRowTypesInversed['discountForTotalFooter']} onChange={(value) => handleChangeFinancialRows(rowData.absoluteIndex, 'beforeTax', value)} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + allRowData.rowIndex} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => deleteRow(allRowData.absoluteIndex)} />,
        }
    ]
    if (isReadOnly) {
        return <ModalFinancialRowsOrderReadOnlyTable titleReadOnly={t('recharges', 'Recargos')} {...{ isReadOnly, financialRowTypesDict, headerData, OrderId, ...rest }} />
    }
    return (<ModalFinancialRowsOrderEditTable titleFinancialEdit={t('addEditRecharges', 'Añadir o editar recargos')} {...{ isReadOnly, financialRowTypesDict, headerData, OrderId, myColumns, addTotalDiscountRow, ...rest }} />)
}

export default ModalAddRechargesOrder